export const getTotalPagesCount = (totalItems: number, perPage: number): number => {
  return Math.ceil(totalItems / perPage);
};
